import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import type { TreatmentCaseSummaryResponse } from "@/shared/types/type/treatment";
import { getSafeImageSrc } from "@/shared/utils/image";
interface ContentRecentCaseCardProps {
  item: TreatmentCaseSummaryResponse;
  priority?: boolean;
  locale?: string;
}
const ContentRecentCaseCard = t0 => {
  const $ = _c(30);
  const {
    item,
    priority: t1,
    locale
  } = t0;
  const priority = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== item.hospitalThumbnailUrl) {
    t2 = getSafeImageSrc(item.hospitalThumbnailUrl, "");
    $[0] = item.hospitalThumbnailUrl;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const hospitalThumbnailUrl = t2;
  let t3;
  if ($[2] !== item.thumbnail.afterImageUrl) {
    t3 = getSafeImageSrc(item.thumbnail.afterImageUrl, "");
    $[2] = item.thumbnail.afterImageUrl;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const listImageUrl = t3;
  const t4 = `${locale ? `/${locale}` : ""}/treatment-case/${item.treatmentCaseId}`;
  let t5;
  if ($[4] !== item.title) {
    t5 = <h3 className="line-clamp-2 pr-2 text-[16px] font-semibold leading-[22px] text-gray-800">{item.title}</h3>;
    $[4] = item.title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== hospitalThumbnailUrl) {
    t6 = hospitalThumbnailUrl && <Image src={hospitalThumbnailUrl} alt="" width={24} height={24} className="size-6 object-cover" />;
    $[6] = hospitalThumbnailUrl;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <span className="relative size-6 shrink-0 overflow-hidden rounded-full bg-gray-100">{t6}</span>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== item.hospitalOriginName) {
    t8 = <p className="truncate text-[14px] font-medium leading-[22px] text-gray-600">{item.hospitalOriginName}</p>;
    $[10] = item.hospitalOriginName;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="size-0.5 shrink-0 rounded-full bg-gray-300" aria-hidden={true} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== item.createdAt) {
    t10 = <time className="shrink-0 text-[14px] leading-[22px] tracking-[-0.02em] text-gray-300">{item.createdAt}</time>;
    $[13] = item.createdAt;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t7 || $[17] !== t8) {
    t11 = <div className="flex min-w-0 items-center gap-1">{t7}{t8}{t9}{t10}</div>;
    $[15] = t10;
    $[16] = t7;
    $[17] = t8;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t5) {
    t12 = <div className="flex h-full min-w-0 flex-1 flex-col justify-between pt-1">{t5}{t11}</div>;
    $[19] = t11;
    $[20] = t5;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== item.title || $[23] !== listImageUrl || $[24] !== priority) {
    t13 = <div className="relative size-20 shrink-0 overflow-hidden rounded-lg bg-gray-100">{listImageUrl ? <Image src={listImageUrl} alt={item.title} width={80} height={80} className="size-full object-cover" priority={priority} /> : <div className="size-full bg-gray-100" role="img" aria-label={`${item.title} 이미지 없음`} />}</div>;
    $[22] = item.title;
    $[23] = listImageUrl;
    $[24] = priority;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13 || $[28] !== t4) {
    t14 = <Link href={t4} className="flex h-32 items-center border-b border-gray-100 py-5 last:border-b-0">{t12}{t13}</Link>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t4;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
export default ContentRecentCaseCard;